module.exports = __webpack_public_path__ + "static/media/expanded.6a9bdf84.svg";